/** Custom roles (ADR 0018): an organization's named staff roles and their permissions. */
import { z } from "zod";
/** The same keys as @mubin/domain PERMISSIONS (a domain test keeps them equal). */
export const PERMISSION_VALUES = [
    "circles.view",
    "circles.manage",
    "enrollments.manage",
    "users.view",
    "users.manage",
    "users.roles",
    "join.manage",
    "volunteers.manage",
    "interviews.conduct",
    "interviews.slots",
    "plans.view",
    "plans.edit",
    "plans.approve",
    "attendance.view",
    "attendance.edit",
    "recitation.view",
    "results.revise",
    "exams.view",
    "exams.manage",
    "exams.approve",
    "reports.view",
    "notifications.send",
    "policies.manage",
    "branches.manage",
    "programs.manage",
    "settings.manage",
    "audit.view",
    "deletion.manage",
];
export const Permission = z.enum(PERMISSION_VALUES);
export const ProfileLevel = z.enum(["org_admin", "branch_manager", "supervisor"]);
export const RoleProfile = z.object({
    id: z.uuid(),
    name: z.string(),
    level: ProfileLevel,
    permissions: z.array(Permission),
    /** Active grants that use it. */
    holders: z.number().int(),
    archived: z.boolean(),
});
export const RoleProfilesQuery = z.object({ organizationId: z.uuid() });
export const RoleProfilesResponse = z.object({
    profiles: z.array(RoleProfile),
    /** What each level does when a grant names no profile. */
    defaults: z.record(ProfileLevel, z.array(Permission)),
    /** The permissions a profile of each level may hold. */
    allowed: z.record(ProfileLevel, z.array(Permission)),
});
const profileName = z.string().trim().min(2).max(60);
export const CreateRoleProfileBody = z.object({
    organizationId: z.uuid(),
    name: profileName,
    level: ProfileLevel,
    permissions: z.array(Permission).max(50),
});
export const UpdateRoleProfileBody = z.object({
    name: profileName.optional(),
    permissions: z.array(Permission).max(50).optional(),
    archived: z.boolean().optional(),
});
export const RoleProfileResponse = z.object({ profile: RoleProfile });
//# sourceMappingURL=roles.js.map